import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { RegistrationFlowStep } from 'src/app/constants/registration-flow.constants';
import { ADD_PET_ID_STORAGE_KEY, ADD_PET_QUERY_PARAM } from 'src/app/constants/route.constants';
import { ActivatedRoute, Router } from '@angular/router';

import { ErrorStrings } from 'src/app/constants/form.constants';
import { Alert } from 'src/app/interfaces/alert';
import { PetService } from 'src/app/services/pet/pet.service';
import { HttpErrorResponse } from '@angular/common/http';
import { User } from 'src/app/interfaces/user';
import { PetStatus, Pet, PetGender, PetSpeciesFilterableType, PetSpecies } from 'src/app/interfaces/pet';
import { merge, Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';
import {
  NgbCalendar,
  NgbDate,
  NgbDateStruct,
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
  NgbTypeahead,
} from '@ng-bootstrap/ng-bootstrap';
import { BreedSelectorModalComponent } from 'src/app/modals/breed-selector-modal/breed-selector-modal.component';
import { CommonUtilService } from 'src/app/services/common/common-util.service';
import {
  RedirectionParams,
  RedirectionService,
} from 'src/app/services/redirection/redirection.service';
import {
  RegistrationProgressData,
} from 'src/app/services/registration-progress/registration-progress.service';
import { UserService } from 'src/app/services/user/user.service';
import { RegistrationFlowService } from 'src/app/services/registration-flow/registration-flow.service';
import { Species } from 'src/app/interfaces/species';
import { isPlatformBrowser } from '@angular/common';
import { ConfigService } from '../../../../services/config/config.service';
import { FeatureFlagsService } from '../../../../services/feature-flag/feature-flag.service';
import { PerkService } from '../../../../services/perk/perk.service';
import { PetplanService } from 'src/app/services/petplan/petplan.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-edit-v2',
  templateUrl: './edit-v2.component.html',
  styleUrl: './edit-v2.component.scss'
})
export class EditV2Component {

  public RegistrationFlowStep = RegistrationFlowStep;
  // The registration stepper is only shown until the user completes the pet details step
  public showProgressStepper = false;
  errorStrings = ErrorStrings;
    pet: Pet;
    loading = false;
    alert: Alert = null;
    currentPetName: string;
    isConfirm: boolean;
    user: User;
  
    isNewPet = false;
    loadingSpecies = false;
    loadingBreeds = false;
    speciesList: Species[] = [];
    selectedSpecies: Species = null;
    breedsNamesList: string[] = [];
    breedVenomCodesByBreedNames: { [name: string]: number } = {};
    petGender = PetGender;
    petDobValue: NgbDateStruct;
    petImplantDateValue: NgbDateStruct;
    today: NgbDate;
    minDate: NgbDateStruct;
    breedSelectorModalRef?: NgbModalRef;
    redirectParams?: RedirectionParams;
    addAnotherPet: boolean;
    canAddAnotherPet: boolean;
    currentPetIndex?: number = null;
    sortedPets: Pet[];
    // Started from the add pet buttons, or finishing a pet claimed from them: saving the pet goes on to
    // the steps after pet details
    isAddPetFlow: boolean;
    userRegistrationIsInProgress: boolean = false;
    showIndoorOutdoorSection: boolean = false;
    checkedIsIndoor: boolean = false;
    checkedIsOutdoor: boolean = false;
    isBrowser: boolean;
    public petDetailColorsFieldTitle = this.configService.getTextFromKey('colors-and-markings-title');
    public petDetailDistinguishingFeaturesTitle = this.configService.getTextFromKey(
      'distinguishing-features-title',
    );
    public petPlanText1 = this.configService.getTextFromKey('pet-details-page-petplan-text-1');
    public petPlanText2 = this.configService.getTextFromKey('pet-details-page-petplan-text-2');
    public petPlanCheckboxLabel = this.configService.getTextFromKey('pet-details-page-petplan-checkbox-label');
    public isPetPlanCheckboxChecked = false;
    public showPetPlanTextBox = false;
  
    @ViewChild('petBreedTypeahead') petBreedTypeahead: NgbTypeahead;
    focus$ = new Subject<string>();
    click$ = new Subject<string>();
  
    constructor(
      private router: Router,
      private route: ActivatedRoute,
      private petService: PetService,
      private petplanService: PetplanService,
      private calendar: NgbCalendar,
      private modalService: NgbModal,
      private commonUtilService: CommonUtilService,
      private redirectionService: RedirectionService,
      private registrationFlowService: RegistrationFlowService,
      private userService: UserService,
      private configService: ConfigService,
      private featureFlagService: FeatureFlagsService,
      private perkService: PerkService,
      @Inject(PLATFORM_ID) private platformId: Object,
    ) {
      this.user = this.route.snapshot.data.user as User;
      this.pet = this.route.snapshot.data.pet as Pet;
      this.isConfirm = this.route.snapshot.url[0].path === 'confirm';
      this.today = this.calendar.getToday();
      this.minDate = {
        day: 1,
        month: 1,
        year: this.today.year - 99,
      };
  
      this.sortedPets = this.userService.getPetsForUserOrderedById(this.user);
      this.currentPetIndex = this.sortedPets.indexOf(
        this.sortedPets.find((p) => p.id === this.pet.id)
      );
  
      // The add another pet button should only be visible, if this is the last existing pet to review for the user.
      this.canAddAnotherPet = this.currentPetIndex === this.sortedPets.length - 1;
      this.isBrowser = isPlatformBrowser(this.platformId);
      this.isAddPetFlow =
        this.route.snapshot.queryParams[ADD_PET_QUERY_PARAM] === 'true' ||
        (this.isBrowser && localStorage.getItem(ADD_PET_ID_STORAGE_KEY) === String(this.pet.id));
    }
  
    getGender = this.petService.getGender;
  
    onSaveAndAddAnotherButtonClick(): void {
      this.addAnotherPet = true;
    }
  
    public getProgressData() {
      const result: RegistrationProgressData = {
        isFullNameRegistrationCompleted: true,
        isPetChipNumberRegistrationCompleted: false,
        isMembershipSelectionCompleted: false,
        isWelcomePackSelectCompleted: false,
      };
      return result;
    }
  
    updateSelectedBreed(): void {
      // Update pet breed code based on selected breed name
      this.pet.breedVenomCode = this.breedVenomCodesByBreedNames[this.pet.breed];
    }
  
    save(): void {
      if (this.isConfirm) {
        this.trackEvent('registerchip::petdetails::submitted');
      }
      if (this.isNewPet) {
        this.pet.implantDate = this.commonUtilService.createDateObject(this.petImplantDateValue);
      }
      this.pet.dob = this.commonUtilService.createDateObject(this.petDobValue);
      this.closeAlert();
      this.loading = true;
      this.petService
        .saveOne(this.pet)
        .subscribe(
          (pet) => {
            this.alert = {
              type: 'success',
              message: 'Your pet information has been updated.',
            };
            this.pet = pet;
            this.currentPetName = this.pet.name.trim();
  
            if (
              this.featureFlagService.isEnabled('isFreePetInsuranceCheckBoxAvailable') &&
              this.isPetPlanCheckboxChecked
            ) {
              this.petplanService.petplanSave(this.pet.id).subscribe();
            }
  
            this.handleSuccessRedirection();
            if (!this.isConfirm) {
              this.trackEvent('petpage::editpet::saved');
            }
          },
          (err) => {
            if (err instanceof HttpErrorResponse && err.status === 400) {
              this.alert = {
                type: 'danger',
                message: err.error?.error_message ?? '',
              };
            } else {
              this.alert = {
                type: 'danger',
                message: 'An error has occurred. Please try again later.',
              };
            }
          }
        )
        .add(() => {
          this.loading = false;
        });
    }
  
    closeAlert() {
      this.alert = null;
    }
  
    toggleOutdoor(isOutdoors: boolean): void {
      this.pet.isOutdoors = !this.checkedIsIndoor && !this.checkedIsOutdoor ? null : isOutdoors;
      this.checkedIsIndoor = !isOutdoors;
      this.checkedIsOutdoor = isOutdoors;
    }
  
    setCheckboxesBasedPetData(isOutdoors: boolean | null): void {
      // Set checkboxes based on isOutdoors value
      this.checkedIsIndoor = !isOutdoors;
      this.checkedIsOutdoor = isOutdoors;
    }
  
    updateBreedsList(disableAutocomplete?: boolean): void {
      if (!this.selectedSpecies) {
        return;
      }
  
      // Loading breeds list
      this.breedsNamesList = [];
      this.breedVenomCodesByBreedNames = {};
      this.loadingBreeds = true;
      this.pet.species = this.selectedSpecies.description;
      this.showIndoorOutdoorSection = this.user.pets.length === 1 && this.selectedSpecies.description.split(' ')[0] === PetSpecies.Cat;
      this.petService
        .getBreedsFor(this.selectedSpecies.venomCode)
        .subscribe(
          (breedsList) => {
            this.breedsNamesList = Object.keys(breedsList);
            this.breedVenomCodesByBreedNames = breedsList;
            if (!disableAutocomplete) {
              if (this.breedsNamesList.length === 1) {
                this.pet.breed = this.breedsNamesList[0];
                this.updateSelectedBreed();
              } else {
                this.pet.breed = null;
              }
            }
          },
          (err) => {
            this.alert = {
              type: 'danger',
              message:
                'An error has occurred while retrieving some information. Please try again later.',
            };
          }
        )
        .add(() => {
          this.loadingBreeds = false;
        });
    }
  
    searchBreed = (text$: Observable<string>) => {
      const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
      const clicksWithClosedPopup$ = this.click$.pipe(
        filter(() => !this.petBreedTypeahead.isPopupOpen())
      );
      const inputFocus$ = this.focus$;
      return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
        map((term) => {
          if (term === '') {
            return this.breedsNamesList.length <= 10 ? this.breedsNamesList : [];
          } else {
            return this.breedsNamesList
              .filter((v) => v.toLowerCase().indexOf(term.toLowerCase()) > -1)
              .slice(0, 10);
          }
        })
      );
    };
  
    openBreedSelector = () => {
      const modalOptions: NgbModalOptions = {
        centered: true,
        size: 'lg',
        scrollable: true,
      };
      this.breedSelectorModalRef = this.modalService.open(BreedSelectorModalComponent, modalOptions);
      this.breedSelectorModalRef.componentInstance.breeds = this.breedsNamesList;
      this.breedSelectorModalRef.result
        .then((selected) => {
          this.pet.breed = selected;
        })
        .catch(() => {});
    };
  
    private updateRegistrationState(): void {
      this.userRegistrationIsInProgress = this.registrationFlowService.getCurrentStep() !== RegistrationFlowStep.Dashboard;
    }
  
    private handleSuccessRedirection(): void {
      this.updateRegistrationState();
  
      // A keeper adding a pet once pet details is done goes on to the step that follows it in their flow,
      // without completing it again. Steps that didn't load count as done, as adding a pet normally comes
      // after registration
      const isPetDetailsDone =
        !this.registrationFlowService.getSteps() ||
        this.registrationFlowService.isStepCompleted(RegistrationFlowStep.PetDetails);
      if (this.isAddPetFlow && isPetDetailsDone) {
        const nextRoute = this.registrationFlowService.getNextRoute(RegistrationFlowStep.PetDetails);
        this.router.navigate([nextRoute ?? '/account/membership-options']);
        return;
      }

      if (this.userRegistrationIsInProgress) {
        // Check if there is another existing pet to review, before we can move on to the next step of the registration
        if (this.currentPetIndex < this.sortedPets.length - 1) {
          const nextPet = this.sortedPets[this.currentPetIndex + 1];
          this.router.navigate(['/my-pet', nextPet.id, 'confirm']);
          return;
        }
  
        // If the registration of the user is not finished, and they clicked add another pet, we redirect the user to add a new pet
        if (this.addAnotherPet) {
          this.router.navigate(['/claim-pet']);
          return;
        }
  
        // Registration is not finished and they clicked next, so complete pet details and go to the step
        // that follows it in the user's flow: membership selection when it exists, or the dashboard for
        // the skip-steps flow. Falls back to membership-options when the steps are not loaded.
        this.registrationFlowService.completeStep(RegistrationFlowStep.PetDetails).subscribe(() => {
          const nextRoute = this.registrationFlowService.getNextRoute(RegistrationFlowStep.PetDetails);
          this.router.navigate([nextRoute ?? '/account/membership-options']);
        });
        return;
      }
  
      if (this.redirectParams) {
        if (this.route.snapshot.queryParams.r && !this.redirectParams.l) {
          this.router.navigate([`/${this.route.snapshot.queryParams.r}`]);
        } else {
          this.router.navigate(this.redirectParams.l, {
            queryParams: this.redirectParams.q,
            fragment: this.redirectParams.f,
          });
        }
      } else if (this.isConfirm && this.userService.isUserBasic(this.user.productType)) {
        this.router.navigate(['/dashboard']);
      } else {
        this.router.navigate(['/my-pet', this.pet.id]);
      }
    }
  
    private ifNewPetUpdatePropertiesAndView(): void {
      if (this.pet.name === '[to_be_completed_by_keeper]') {
        // Setting property to conditionally show content on the view
        this.isNewPet = true;
        this.isConfirm = true;
  
        // Clearing pet object properties
        this.pet.name = null;
        this.pet.dob = null;
        this.pet.species = null;
        this.pet.implantDate = null;
        this.pet.breed = null;
        this.pet.gender = null;
        this.pet.neutered = null;
        this.pet.coloursMarkings = null;
        this.pet.existingConditions = null;
        this.pet.instagram = null;
      } else {
        this.loadDobValue();
      }
    }
  
    private loadSpecies(): void {
      // Loading species list
      this.loadingSpecies = true;
      this.petService
        .getAllSpecies()
        .subscribe(
          (speciesList) => {
            this.speciesList = speciesList;
            if (this.pet && this.pet.species) {
              const petSpecies = this.speciesList.find((s) => s.venomCode === this.pet.speciesCode);
              if (petSpecies) {
                this.selectedSpecies = petSpecies;
              }
            }
            this.updateBreedsList(!!this.pet.breed);
          },
          (err) => {
            this.alert = {
              type: 'danger',
              message:
                'An error has occurred while retrieving some information. Please try again later.',
            };
          }
        )
        .add(() => {
          this.loadingSpecies = false;
        });
    }
  
    private loadDobValue(): void {
      if (this.pet.dob) {
        this.petDobValue = NgbDate.from({
          day: this.pet.dob.getDate(),
          month: this.pet.dob.getMonth() + 1,
          year: this.pet.dob.getFullYear(),
        });
      }
    }
  
    trackEvent(event: string) {
      if (!this.isBrowser) return;
      window.analytics.track(event);
    }
  
    ngOnInit(): void {
      this.updateRegistrationState();
      this.registrationFlowService.loadSteps().subscribe(() => {
        this.showProgressStepper = !this.registrationFlowService.isStepCompleted(RegistrationFlowStep.PetDetails);
      });
  
      this.loadSpecies();
      if (this.pet.breed) {
        this.updateBreedsList(true);
      }
  
      this.showIndoorOutdoorSection = this.user.pets.length === 1 && this.pet.speciesFilter === PetSpeciesFilterableType.Cat;
      // This is required to manage pets claimed that got a pet attached during the claiming process
      this.ifNewPetUpdatePropertiesAndView();
  
      // This is required to avoid the two-way data binding on the form to update the title
      this.currentPetName = this.pet.name?.trim() || null;
  
      // Initialize indoor/outdoor checkboxes based on pet data
      this.setCheckboxesBasedPetData(this.pet.isOutdoors);
  
      // Keeper shouldn't be able to edit pet details once is marked as deceased
      if (this.pet.status === PetStatus.Deceased) {
        this.router.navigate(['/my-pets']);
      }
  
      // Setting redirection to be used when details are saved or when pressing back
      this.redirectParams = this.redirectionService.getParams(this.route.snapshot.queryParams.r);
      
      if (this.featureFlagService.isEnabled('isPetPlanFreeInsuranceAvailable')) {
        this.perkService
          .getPetEligibilityFromChipNumber(Number(this.pet.chipNumber), environment.eligibilityShortCode)
          .subscribe((res) => {
            this.showPetPlanTextBox = res.isEligible;
          });
      }
    }
  
    ngOnDestroy(): void {
      if (this.breedSelectorModalRef) {
        this.breedSelectorModalRef.dismiss('destroyed');
      }
    }
  
    public checkValue(checked: boolean) {
      this.isPetPlanCheckboxChecked = checked;
    }

}
